import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs';
import { UserEducationInfo } from '../models/applicant-education-info';

@Injectable({
  providedIn: 'root'
})
export class ApplicantEducationInfoService extends HttpBaseService {

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.ApplicantEducationInfo, notifyServ, localizationService, configService);
  }

  getListApplicantEducationInfo(filter: any): Observable<UserEducationInfo[]> {
    return this.post("GetListApplicantEducationInfo", filter, true);
  }
  save(obj: UserEducationInfo): Observable<any> {
    return this.post("SaveAsync", obj, true);
  }
}